export default __webpack_public_path__ + "static/media/aplikasi-2.1b0e0928.jpg";